(() => {
  // app/scripts/product-description.js
  var theme = {
    debounceTime: function (callback, delay) {
      var timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          callback.apply(this, args);
        }, delay);
      };
    },
  };

  class ProductDescription extends HTMLElement {
    constructor() {
      super();
      // this.updateLayout();
      this.handleClickTab();
      this.handleAccordion();
      this.setHeightTab();
      window.addEventListener(
        "resize",
        theme
          .debounceTime((e) => {
            // this.updateLayout();
            this.setHeightTab();
          }, 300)
          .bind(this)
      );
    }
    handleAccordion() {
      const listTab = this.querySelectorAll(".tab__panel-title");
      listTab.forEach((currentTab) => {
        currentTab.addEventListener("click", () => {
          listTab.forEach((tab) => {
            if (tab !== currentTab) {
              tab.closest("details")?.removeAttribute("open");
            }
          });
        });
      });
    }
    handleClickTab() {
      const listButton = document.querySelectorAll(".jsToggleClass");
      listButton.forEach((btn) => {
        btn.addEventListener("click", () => {
          const id = btn.dataset.id;
          this.createActiveBodyDesktop(id);
        });
      });
    }

    setHeightTab() {
      const currentDevice = this.getDevice();
      const tabBody = document.querySelector(".tab__panel-body");
      if (currentDevice == "desktop") {
        const tabElements = document.querySelectorAll(
          ".tab__panel-body .jsTab"
        );

        let maxHeight = 0;

        tabElements.forEach(function (element) {
          const elementHeight = element.clientHeight;
          if (elementHeight > maxHeight) {
            maxHeight = elementHeight;
          }
        });
        tabBody.style.height = `${maxHeight}px`;
      } else {
        tabBody.style.height = "auto";
      }
    }
    createActiveBodyDesktop(id) {
      const targetElement = document.querySelector(
        `.tab__panel-content.jsTab[data-id="${id}"]`
      );
      document
        .querySelector(".tab__panel-content.jsTab.active")
        ?.classList.remove("active");
      targetElement?.classList.add("active");
      const targetHeader = document.querySelector(`.jsNavTab[data-id="${id}"]`);
      document.querySelector(".jsNavTab.active")?.classList.remove("active");
      targetHeader?.classList.add("active");
    }
    updateLayout() {
      const currentDevice = this.getDevice();
      if (this.lastDevice === currentDevice) return;
      this.querySelectorAll("details").forEach((item) => {
        item.open = currentDevice === "desktop";
      });
      this.lastDevice = currentDevice;
    }

    getDevice() {
      return window.matchMedia("(min-width: 750px)").matches
        ? "desktop"
        : "mobile";
    }
  }

  customElements.define("product-description-component", ProductDescription);
})();
